import React from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

import * as ApplicationConstant from "../../../Constants/ApplicationConstant";

import LogService from "../../../../middleware/CommonSdk/LogService";

const LOG_TAG = "APP-EDITION-INFORMATION-INPUT";

const InformationInput = (props) => {
    const intl = useIntl();

    const handleUpdate = (name, activity, type) => {
        LogService.trace(LOG_TAG, "handleUpdate");
        if (props.onUpdate) {
            props.onUpdate(name, activity, type);
        }
    };

    const handleNameChange = (event) => {
        handleUpdate(event.target.value, props.activity, props.type);
    };

    const handleActivityChange = (event) => {
        LogService.trace(LOG_TAG, "handleActivityChange");
        handleUpdate(props.name, event.target.value, props.type);
    }

    const handleTypeChange = (event) => {
        LogService.trace(LOG_TAG, "handleTypeChange");
        handleUpdate(props.name, props.activity, event.target.value);
    };


    // LogService.trace(LOG_TAG, "render");

    let typeListOptions = Object.entries(ApplicationConstant.TypeLabel).map(([key, value]) => {
        return (
            <option value={key} key={key}>
                {value.label}
            </option>
        );
    });

    let activityListOptions = Object.entries(ApplicationConstant.ActivityLabel).map(([key, value]) => {
        return (
            <option value={key} key={key}>
                {value}
            </option>
        );
    });

    return (
        <form onSubmit={(event) => event.preventDefault()}>
            <div className="form-group">
                <label className="input-label">{intl.messages.applicationEditionInformationName}</label>
                <input name="applicationName"
                    value={props.name}
                    type="text"
                    className="form-control"
                    autoComplete="off"
                    onChange={handleNameChange}
                    disabled={!props.isUpdateEnabled}
                />
            </div>
            <div className="form-row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label className="input-label">{intl.messages.applicationEditionInformationTarget}</label>
                        <select className="form-control mb-3"
                            id="typeSelect"
                            value={props.type}
                            onChange={handleTypeChange}
                            disabled={!props.isUpdateEnabled}>
                            {typeListOptions}
                        </select>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <label className="input-label">{intl.messages.applicationEditionInformationActivity}</label>
                        <select
                            id="activitySelect"
                            className="form-control mb-3"
                            value={props.activity}
                            onChange={handleActivityChange}
                            disabled={!props.isUpdateEnabled}>
                            {activityListOptions}
                        </select>
                    </div>
                </div>
            </div>
        </form>
    );
}

InformationInput.propTypes = {
    name: PropTypes.string,
    activity: PropTypes.string,
    type: PropTypes.string,
    isUpdateEnabled: PropTypes.bool,
    onUpdate: PropTypes.func
};

InformationInput.defaultProps = {
    name: "",
    activity: ApplicationConstant.Activity.J,
    type: ApplicationConstant.Type.Web,
    isUpdateEnabled: false,
    onUpdate: null
}

export default InformationInput;